import type { HotelRoomOptionsRequest } from 'tripPlanner/api/types'

export const all = ['offerDetail'] as const
export const detail = (offerId: string, region: string, accommodationPropertyId?: string, offerType?: string, checkIn?: string, checkOut?: string, occupancies?: string, flexibleMonths?: string, flexibleNights?: string, orderId?: string) =>
  [...all, offerId, region, accommodationPropertyId, offerType, checkIn, checkOut, occupancies, flexibleMonths, flexibleNights, orderId] as const
/**
 * One offer's entry from the batch endpoint. Namespaced separately from `detail` because the
 * cached value is the batch's `{ status: 'ok' | 'error' }` union rather than a bare detail, so
 * it must never be served to a `detail` consumer. The parameters do not line up either: every
 * caller of `detail` knows the offer's `offerType`, and the batch — which asks for details it
 * does not have yet — cannot.
 */
export const batchEntry = (offerId: string, region: string, checkIn?: string, checkOut?: string, occupancies?: string) =>
  [...all, 'batch', offerId, region, checkIn, checkOut, occupancies] as const
export const reviews = (offerId: string, region: string) =>
  [...all, 'reviews', offerId, region] as const
export const roomOptions = (
  offerId: string,
  region: string,
  checkIn: string | undefined,
  checkOut: string | undefined,
  nights: number | undefined,
  rooms: HotelRoomOptionsRequest['rooms'],
  selections: HotelRoomOptionsRequest['selections'],
  inventoryRateIds?: Array<string>,
) =>
  [...all, 'roomOptions', offerId, region, checkIn, checkOut, nights, rooms, selections, inventoryRateIds] as const
